export class MapExtentTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        calculateExtents: "Skapa om utsnitt",
        createNewExtent: "Ny detaljkarta",
        deleteSelectedExtent: "Ta bort",
        loadExtents: "Ladda kartutsnitt",
        notImplemented: "NOT IMPLEMENTED",
        saveExtents: "Spara kartutsnitt",
        scale: "Skala",
        virkesorderTitle: "Virkesorder"
    };
}
